const data = {
  pinyin: {
    genesis: 'Chuàngshìjì',
    exodus: 'Chū\'āijíjì',
    leviticus: 'Lìwèijì',
    numbers: 'Mínshùjì',
    deuteronomy: 'Shēnmìngjì',
    joshua: 'Yuēshūyàjì',
    judges: 'Shìshījì',
    ruth: 'Lùdéjì',
    '1samuel': 'Sāmǔ\'ěrjìshàng',
    '2samuel': 'Sāmǔ\'ěrjìxià',
    '1kings': 'Lièwángjìshàng',
    '2kings': 'Lièwángjìxià',
    '1chronicles': 'Lìdàizhìshàng',
    '2chronicles': 'Lìdàizhìxià',
    ezra: 'Yǐsīlājì',
    nehemiah: 'Níxīmǐjì',
    esther: 'Yǐsītiējì',
    job: 'Yuēbójì',
    psalms: 'Shīpiān',
    proverbs: 'Zhēnyán',
    ecclesiastes: 'Chuándàoshū',
    songofsolomon: 'Yǎgē',
    isaiah: 'Yǐsàiyàshū',
    jeremiah: 'Yēlìmǐshū',
    lamentations: 'Yēlìmǐ\'āigē',
    ezekiel: 'Yǐxījiéshū',
    daniel: 'Dànyǐlǐshū',
    hosea: 'Héxī\'āshū',
    joel: 'Yuēěrshū',
    amos: 'Āmósīshū',
    obadiah: 'Ébādǐyàshū',
    jonah: 'Yuēnáshū',
    micah: 'Míjiāshū',
    nahum: 'Nāhóngshū',
    habakkuk: 'Hābāgǔshū',
    zephaniah: 'Xīfānyǎshū',
    haggai: 'Hāgāishū',
    zechariah: 'Sājiālìyàshū',
    malachi: 'Mǎlājīshū',
    matthew: 'Mǎtàifúyīn',
    mark: 'Mǎkěfúyīn',
    luke: 'Lùjiāfúyīn',
    john: 'Yuēhànfúyīn',
    acts: 'Shǐtúxíngzhuàn',
    romans: 'Luómǎshū',
    '1corinthians': 'Gēlínduōqiánshū',
    '2corinthians': 'Gēlínduōhòushū',
    galatians: 'Jiālātàishū',
    ephesians: 'Yǐfúsuǒshū',
    philippians: 'Féilìbǐshū',
    colossians: 'Gēluōxīshū',
    '1thessalonians': 'Tiēsāluōníjiāqiánshū',
    '2thessalonians': 'Tiēsāluōníjiāhòushū',
    '1timothy': 'Tímótàiqiánshū',
    '2timothy': 'Tímótàihòushū',
    titus: 'Tíduōshū',
    philemon: 'Féilìménshū',
    hebrews: 'Xībóláishū',
    james: 'Yǎgèshū',
    '1peter': 'Bǐdéqiánshū',
    '2peter': 'Bǐdéhòushū',
    '1john': 'Yuēhànyīshū',
    '2john': 'Yuēhànèrshū',
    '3john': 'Yuēhànsānshū',
    jude: 'Yóudàshū',
    revelation: 'Qǐshìlù',
  },
  'pinyin-abbr': {
    genesis: 'Chuàng',
    exodus: 'Chū',
    leviticus: 'Lì',
    numbers: 'Mín',
    deuteronomy: 'Shēn',
    joshua: 'shū',
    judges: 'Shì',
    ruth: 'dé',
    '1samuel': 'Sāshàng',
    '2samuel': 'Sāxià',
    '1kings': 'wángshàng',
    '2kings': 'wángxià',
    '1chronicles': 'dàishàng',
    '2chronicles': 'dàixià',
    ezra: 'lā',
    nehemiah: 'Ní',
    esther: 'sī',
    job: 'bó',
    psalms: 'Shī',
    proverbs: 'Zhēn',
    ecclesiastes: 'Chuán',
    songofsolomon: 'gē',
    isaiah: 'sài',
    jeremiah: 'Yē',
    lamentations: 'āi',
    ezekiel: 'jié',
    daniel: 'Dàn',
    hosea: 'Hé',
    joel: 'ěr',
    amos: 'mó',
    obadiah: 'É',
    jonah: 'ná',
    micah: 'Mí',
    nahum: 'hóng',
    habakkuk: 'Hā',
    zephaniah: 'fān',
    haggai: 'gāi',
    zechariah: 'yà',
    malachi: 'Mǎ',
    matthew: 'tài',
    mark: 'kě',
    luke: 'Lù',
    john: 'Yuē',
    acts: 'tú',
    romans: 'Luó',
    '1corinthians': 'línqián',
    '2corinthians': 'línhòu',
    galatians: 'Jiā',
    ephesians: 'fú',
    philippians: 'Fé',
    colossians: 'xī',
    '1thessalonians': 'Tiēqián',
    '2thessalonians': 'Tiēhòu',
    '1timothy': 'Tíqián',
    '2timothy': 'Tíhòu',
    titus: 'duō',
    philemon: 'mén',
    hebrews: 'lái',
    james: 'Yǎ',
    '1peter': 'Bǐqián',
    '2peter': 'Bǐhòu',
    '1john': 'Yuēyī',
    '2john': 'Yuēèr',
    '3john': 'Yuēsān',
    jude: 'Yóu',
    revelation: 'Qǐ',
  },
  'cmn-hans': {
    genesis: '创世记',
    exodus: '出埃及记',
    leviticus: '利未记',
    numbers: '民数记',
    deuteronomy: '申命记',
    joshua: '约书亚记',
    judges: '士师记',
    ruth: '路得记',
    '1samuel': '撒母耳记上',
    '2samuel': '撒母耳记下',
    '1kings': '列王纪上',
    '2kings': '列王纪下',
    '1chronicles': '历代志上',
    '2chronicles': '历代志下',
    ezra: '以斯拉记',
    nehemiah: '尼希米记',
    esther: '以斯帖记',
    job: '约伯记',
    psalms: '诗篇',
    proverbs: '箴言',
    ecclesiastes: '传道书',
    songofsolomon: '雅歌',
    isaiah: '以赛亚书',
    jeremiah: '耶利米书',
    lamentations: '耶利米哀歌',
    ezekiel: '以西结书',
    daniel: '但以理书',
    hosea: '何西阿书',
    joel: '约珥书',
    amos: '阿摩司书',
    obadiah: '俄巴底亚书',
    jonah: '约拿书',
    micah: '弥迦书',
    nahum: '那鸿书',
    habakkuk: '哈巴谷书',
    zephaniah: '西番雅书',
    haggai: '哈该书',
    zechariah: '撒迦利亚书',
    malachi: '玛拉基书',
    matthew: '马太福音',
    mark: '马可福音',
    luke: '路加福音',
    john: '约翰福音',
    acts: '使徒行传',
    romans: '罗马书',
    '1corinthians': '哥林多前书',
    '2corinthians': '哥林多后书',
    galatians: '加拉太书',
    ephesians: '以弗所书',
    philippians: '腓立比书',
    colossians: '歌罗西书',
    '1thessalonians': '帖撒罗尼迦前书',
    '2thessalonians': '帖撒罗尼迦后书',
    '1timothy': '提摩太前书',
    '2timothy': '提摩太后书',
    titus: '提多书',
    philemon: '腓利门书',
    hebrews: '希伯来书',
    james: '雅各书',
    '1peter': '彼得前书',
    '2peter': '彼得后书',
    '1john': '约翰一书',
    '2john': '约翰二书',
    '3john': '约翰三书',
    jude: '犹大书',
    revelation: '启示录',
  },
  'cmn-hans-abbr': {
    genesis: '创',
    exodus: '出',
    leviticus: '利',
    numbers: '民',
    deuteronomy: '申',
    joshua: '书',
    judges: '士',
    ruth: '得',
    '1samuel': '撒上',
    '2samuel': '撒下',
    '1kings': '王上',
    '2kings': '王下',
    '1chronicles': '代上',
    '2chronicles': '代下',
    ezra: '拉',
    nehemiah: '尼',
    esther: '斯',
    job: '伯',
    psalms: '诗',
    proverbs: '箴',
    ecclesiastes: '传',
    songofsolomon: '歌',
    isaiah: '赛',
    jeremiah: '耶',
    lamentations: '哀',
    ezekiel: '结',
    daniel: '但',
    hosea: '何',
    joel: '珥',
    amos: '摩',
    obadiah: '俄',
    jonah: '拿',
    micah: '弥',
    nahum: '鸿',
    habakkuk: '哈',
    zephaniah: '番',
    haggai: '该',
    zechariah: '亚',
    malachi: '玛',
    matthew: '太',
    mark: '可',
    luke: '路',
    john: '约',
    acts: '徒',
    romans: '罗',
    '1corinthians': '林前',
    '2corinthians': '林后',
    galatians: '加',
    ephesians: '弗',
    philippians: '腓',
    colossians: '西',
    '1thessalonians': '帖前',
    '2thessalonians': '帖后',
    '1timothy': '提前',
    '2timothy': '提后',
    titus: '多',
    philemon: '门',
    hebrews: '来',
    james: '雅',
    '1peter': '彼前',
    '2peter': '彼后',
    '1john': '约一',
    '2john': '约二',
    '3john': '约三',
    jude: '犹',
    revelation: '启',
  },
  'cmn-hant': {
    genesis: '創世記',
    exodus: '出埃及記',
    leviticus: '利未記',
    numbers: '民數記',
    deuteronomy: '申命記',
    joshua: '約書亞記',
    judges: '士師記',
    ruth: '路得記',
    '1samuel': '撒母耳記上',
    '2samuel': '撒母耳記下',
    '1kings': '列王紀上',
    '2kings': '列王紀下',
    '1chronicles': '歷代志上',
    '2chronicles': '歷代志下',
    ezra: '以斯拉記',
    nehemiah: '尼希米記',
    esther: '以斯帖記',
    job: '約伯記',
    psalms: '詩篇',
    proverbs: '箴言',
    ecclesiastes: '傳道書',
    songofsolomon: '雅歌',
    isaiah: '以賽亞書',
    jeremiah: '耶利米書',
    lamentations: '耶利米哀歌',
    ezekiel: '以西結書',
    daniel: '但以理書',
    hosea: '何西阿書',
    joel: '約珥書',
    amos: '阿摩司書',
    obadiah: '俄巴底亞書',
    jonah: '約拿書',
    micah: '彌迦書',
    nahum: '那鴻書',
    habakkuk: '哈巴谷書',
    zephaniah: '西番雅書',
    haggai: '哈該書',
    zechariah: '撒迦利亞書',
    malachi: '瑪拉基書',
    matthew: '馬太福音',
    mark: '馬可福音',
    luke: '路加福音',
    john: '約翰福音',
    acts: '使徒行傳',
    romans: '羅馬書',
    '1corinthians': '哥林多前書',
    '2corinthians': '哥林多後書',
    galatians: '加拉太書',
    ephesians: '以弗所書',
    philippians: '腓立比書',
    colossians: '歌羅西書',
    '1thessalonians': '帖撒羅尼迦前書',
    '2thessalonians': '帖撒羅尼迦後書',
    '1timothy': '提摩太前書',
    '2timothy': '提摩太後書',
    titus: '提多書',
    philemon: '腓利門書',
    hebrews: '希伯來書',
    james: '雅各書',
    '1peter': '彼得前書',
    '2peter': '彼得後書',
    '1john': '約翰一書',
    '2john': '約翰二書',
    '3john': '約翰三書',
    jude: '猶大書',
    revelation: '啟示錄',
  },
  'cmn-hant-abbr': {
    genesis: '創',
    exodus: '出',
    leviticus: '利',
    numbers: '民',
    deuteronomy: '申',
    joshua: '書',
    judges: '士',
    ruth: '得',
    '1samuel': '撒上',
    '2samuel': '撒下',
    '1kings': '王上',
    '2kings': '王下',
    '1chronicles': '代上',
    '2chronicles': '代下',
    ezra: '拉',
    nehemiah: '尼',
    esther: '斯',
    job: '伯',
    psalms: '詩',
    proverbs: '箴',
    ecclesiastes: '傳',
    songofsolomon: '歌',
    isaiah: '賽',
    jeremiah: '耶',
    lamentations: '哀',
    ezekiel: '結',
    daniel: '但',
    hosea: '何',
    joel: '珥',
    amos: '摩',
    obadiah: '俄',
    jonah: '拿',
    micah: '彌',
    nahum: '鴻',
    habakkuk: '哈',
    zephaniah: '番',
    haggai: '該',
    zechariah: '亞',
    malachi: '瑪',
    matthew: '太',
    mark: '可',
    luke: '路',
    john: '約',
    acts: '徒',
    romans: '羅',
    '1corinthians': '林前',
    '2corinthians': '林後',
    galatians: '加',
    ephesians: '弗',
    philippians: '腓',
    colossians: '西',
    '1thessalonians': '帖前',
    '2thessalonians': '帖後',
    '1timothy': '提前',
    '2timothy': '提後',
    titus: '多',
    philemon: '門',
    hebrews: '來',
    james: '雅',
    '1peter': '彼前',
    '2peter': '彼後',
    '1john': '約一',
    '2john': '約二',
    '3john': '約三',
    jude: '猶',
    revelation: '啟',
  },
};

export default (book, type) => data[type][book];
